import { render, staticRenderFns } from "./ProdutosVendidosPorLote.vue?vue&type=template&id=10069fd8&scoped=true&"
import script from "./ProdutosVendidosPorLote.vue?vue&type=script&lang=js&"
export * from "./ProdutosVendidosPorLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10069fd8",
  null
  
)

export default component.exports